
import type { CloudLiveConfig } from './cloudLiveConfig';
import type { LiveSourcePipelineId } from './liveSourceType';

export const supportedLiveSourceProtocols = <const>['srt-listener', 'zixi-push'];
export type SupportedLiveSourceProtocol = typeof supportedLiveSourceProtocols[number];

export interface LiveRecordingParameters {
  /**
   * A CIDR that describes the IP range that is allowed
   * to send content to this flow of the form <IP address>/<bit mask>
   */
  allowedCidr: string;

  /**
   * If defined, the input pipeline to configure to send srt data
   * to the MediaConnect flow that will be created.
   */
  liveSourcePipeline?: LiveSourcePipelineId;

  /**
   * If defined, specifies the settings for the highres and/or proxy,
   * like resolution, framerate and scan type.
   */
  outputSettings?: CloudLiveConfig;

  /**
   * Selected source protocol for the MediaConnect flow
   */
  sourceProtocol: SupportedLiveSourceProtocol | undefined;
}
